module.exports = __webpack_public_path__ + "media/assets/images/tour/6b_Tour_4-7522ca683663292537de3bac4484cab2.png";